/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestUploadUrlTestDto } from '../../models/request-upload-url-test-dto';
import { UrlResponseDto } from '../../models/url-response-dto';

export interface MediaControllerGetTestUploadUrl$Params {
      body: RequestUploadUrlTestDto
}

export function mediaControllerGetTestUploadUrl(http: HttpClient, rootUrl: string, params: MediaControllerGetTestUploadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlResponseDto>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerGetTestUploadUrl.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlResponseDto>;
    })
  );
}

mediaControllerGetTestUploadUrl.PATH = '/thalea-documents/upload-url/test';
